export type TransformFunc<I, O> = (item: I) => O // function for transform item to another
export type SelectFunc<Item> = (item: Item, row?: number, cell?: number) => ColumnIntent

export enum ColumnIntent {
    NONE = 'intent intent-none',
    PRIMARY = 'intent intent-primary',
    WARNING = 'intent intent-warning',
    DANGER = 'intent intent-danger',
}
